import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { LoginService } from '../../login/login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private loginService = inject(LoginService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //On skip si on se log

    if (req.headers.has('Skip-Auth')) {
      const headers = req.headers.delete('Skip-Auth');
      const newReq = req.clone({ headers });
      return next.handle(newReq);
    }

    const authReq = req.clone({
        headers:req.headers.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem("token") ?? '""').access_token}`)
    })


    return next.handle(authReq).pipe(catchError((error) => {

      if([401, 403].includes(error.status)){
          this.loginService.isAlreadyAuthentificated();
      }
      const e = error.error.message || error.statusNext;
      console.error(e);
      return throwError(() => error);

  }));
  }

}
